import { motion } from 'framer-motion';
import React, { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface TextShimmerProps {
  className?: string;
  children: string;
  as?: React.ElementType;
  duration?: number;
  spread?: number;
  length?: number;
}

export const TextShimmer = memo(
  ({ children, className, duration = 1.5, spread = 2, length = 100 }: TextShimmerProps) => {
    const dynamicSpread = children.length * spread;
    const actualLength = length * 2.5;

    return (
      <motion.div
        className={classNames(
          'relative inline-block bg-clip-text text-transparent',
          '[background-repeat:no-repeat,padding-box]',
          '[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))]',
          'dark:[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))]',
          className,
        )}
        initial={{ backgroundPosition: '100% center' }}
        animate={{ backgroundPosition: '0% center' }}
        transition={{
          repeat: Infinity,
          duration,
          ease: 'linear',
        }}
        style={
          {
            '--spread': `${dynamicSpread}px`,
            backgroundImage: `var(--bg), linear-gradient(var(--base-color), var(--base-color))`,
            backgroundSize: `${actualLength}% 100%, auto`,
          } as React.CSSProperties
        }
      >
        {children}
      </motion.div>
    );
  },
);
